import React, { useEffect, useState } from 'react';
interface CountdownBannerProps {
  id?: string;
}
export function CountdownBanner({
  id = 'countdown-1'
}: CountdownBannerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: '00',
    minutes: '00',
    seconds: '00'
  });
  useEffect(() => {
    function updateCountdown() {
      const now = new Date();
      const argentinaOffset = -3 * 60; // GMT-3
      const localOffset = now.getTimezoneOffset();
      const argentinaTime = new Date(now.getTime() + (argentinaOffset - localOffset) * 60000);
      const endOfDay = new Date(argentinaTime);
      endOfDay.setHours(23, 59, 59, 999);
      const diff = endOfDay.getTime() - argentinaTime.getTime();
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor(diff / (1000 * 60) % 60);
      const seconds = Math.floor(diff / 1000 % 60);
      setTimeLeft({
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0')
      });
    }
    const timer = setInterval(updateCountdown, 1000);
    updateCountdown();
    return () => clearInterval(timer);
  }, []);
  return <div id={id} className="bg-[#4a0e17] border-y-2 border-gold py-8 relative overflow-hidden" data-id="element-37">
      {/* Subtle pulse effect background */}
      <div className="absolute inset-0 bg-red-900/50 animate-pulse-slow mix-blend-overlay pointer-events-none" data-id="element-38"></div>

      <div className="container mx-auto px-6 relative z-10 text-center" data-id="element-39">
        <h3 className="text-gold-light font-bold text-lg md:text-xl mb-4 tracking-widest uppercase" data-id="element-40">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h3>

        <div className="flex justify-center items-center gap-2 md:gap-4 font-numbers font-bold text-4xl md:text-6xl text-white mb-4 drop-shadow-lg" data-id="element-41">
          <div className="bg-black/30 px-4 py-2 rounded-lg min-w-[80px] md:min-w-[100px]" data-id="element-42">
            {timeLeft.hours}
            <span className="text-sm md:text-lg block font-sans font-normal text-gold/80 mt-1" data-id="element-43">
              hs
            </span>
          </div>
          <span className="text-gold pb-6" data-id="element-44">:</span>
          <div className="bg-black/30 px-4 py-2 rounded-lg min-w-[80px] md:min-w-[100px]" data-id="element-45">
            {timeLeft.minutes}
            <span className="text-sm md:text-lg block font-sans font-normal text-gold/80 mt-1" data-id="element-46">
              min
            </span>
          </div>
          <span className="text-gold pb-6" data-id="element-47">:</span>
          <div className="bg-black/30 px-4 py-2 rounded-lg min-w-[80px] md:min-w-[100px]" data-id="element-48">
            {timeLeft.seconds}
            <span className="text-sm md:text-lg block font-sans font-normal text-gold/80 mt-1" data-id="element-49">
              seg
            </span>
          </div>
        </div>

        <p className="text-gray-300 text-lg mb-6 italic" data-id="element-50">
          Después sube $4.500 ARS y no vuelve a bajar.
        </p>

        <div className="max-w-md mx-auto" data-id="element-51">
          <p className="text-white font-medium mb-2 flex items-center justify-center gap-2" data-id="element-52">
            <span className="text-red-500 animate-pulse" data-id="element-53">🔴</span> Cupos al
            precio de lanzamiento — Quedan pocos
          </p>
          <div className="w-full bg-black/40 rounded-full h-3 mb-1 overflow-hidden border border-white/10" data-id="element-54">
            <div className="bg-gradient-to-r from-gold-dark via-gold to-red-500 h-3 rounded-full w-[73%]" data-id="element-55"></div>
          </div>
          <p className="text-xs text-gold/80 text-right" data-id="element-56">
            73% de los cupos tomados
          </p>
        </div>
      </div>
    </div>;
}